import { ScrollContainer as FoundationsScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const ScrollContainer = props => {
  return /*#__PURE__*/_jsx(FoundationsScrollContainer, Object.assign({
    gradientColor: "fill-surface-default"
  }, props));
};